import { Action, createReducer, on } from '@ngrx/store';
import {changeRoute} from "@actions/previous-route.action";
import {sendPageViewEvent} from "@actions/gtm.action";

export interface State {
  currentRoute: string;
  previousRoute: string;
}

export const INITIAL_STATE: State = {
  currentRoute: '/',
  previousRoute: '/',
};

const reducer = createReducer(
  INITIAL_STATE,
  on(
    changeRoute,
    sendPageViewEvent,
    (currentState, action): State => ({
      currentRoute: action.url,
      previousRoute: currentState.currentRoute,
    }),
  ),
);

export const previousRouteReducer = (state: State, action: Action): State =>
  reducer(state, action);
